/**
 * @name GameId
 * @type {any}
 */
export const GameId = '141428';

export const PascalGamingPartnerId = 18746949;